module.exports = __webpack_public_path__ + "static/04-e81b3bdbe6e0ea2bf40cfb9483f5d06b.png";